
import {
  Component,
  ViewEncapsulation,
  OnInit,
  TemplateRef,
  ViewChild,
  Input,
  ChangeDetectorRef,
  HostListener,
  CUSTOM_ELEMENTS_SCHEMA
} from '@angular/core';
import { ColumnMode, DataTablePagerComponent, DatatableComponent as DatComp, SortType } from '@swimlane/ngx-datatable';
import { Page } from 'src/app/ui/datatable/page';
import { PaginationObject } from 'src/app/models/paginationObject';
import { SortObject } from 'src/app/models/sortObject';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { ExportToCsv } from 'export-to-csv';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, of } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { UserPersonSharedService } from 'src/app/services/shared/user/person/sharedPerson.service';
import { StringToDate } from 'src/app/utils/stringToDate';
import { ToastService } from 'src/app/services/toast.service';
import { copy2DArrayToClipboard } from 'src/app/utils/copy2DArrayToClipboard';
import { LoadingService } from 'src/app/services/shared/loading.service';
import sortHelper from 'src/app/helpers/sort';
import { FiltersComponent } from './filters/filters.component';
import { NgxCurrencyInputMode } from 'ngx-currency';
declare var gapi: any;

@Component({
  selector: 'app-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DatatableComponent implements OnInit {
  SortType = SortType;
  // used on persona screens
  @ViewChild('plainCell', { static: true }) plainCell: TemplateRef<any>;
  @ViewChild('numberCell', { static: true }) numberCell: TemplateRef<any>;
  @ViewChild('personNameCell', { static: true }) personNameCell: TemplateRef<any>;
  @ViewChild('dateCell', { static: true }) dateCell: TemplateRef<any>;
  @ViewChild('translateCell', { static: true }) translateCell: TemplateRef<any>;
  @ViewChild('percentageCell', { static: true }) percentageCell: TemplateRef<any>;
  @ViewChild('currencyCell', { static: true }) currencyCell: TemplateRef<any>;
  @ViewChild('timeCell', { static: true }) timeCell: TemplateRef<any>;
  @ViewChild('greenEyeIconHomepage', { static: true }) greenEyeIconHomepage: TemplateRef<any>;
  @ViewChild('greenEyeIconAdmin', { static: true }) greenEyeIconAdmin: TemplateRef<any>;
  @ViewChild(FiltersComponent) filtersComponent: FiltersComponent;

  //@ViewChild(DatComp, { static: false }) tableComponent: DatComp;
  @ViewChild('tableComponent', { static: false }) tableComponent: DatComp;
  

  @Input() public service: Function;
  @Input() public defaultColumns: any[] = [];
  @Input() public section: string;
  @Input() public subsection: string;
  @Input() public subsectionRoute: string = null;
  @Input() public enableFilter: boolean = true;
  @Input() public columnsToExclude: string[] = [];
  @Input() public isMultiForm: boolean = false;
  @Input() public isAdministration: boolean = false;
  @Input() public columnsNotToFilter: string[] = [];

  public token: any;
  page = new Page();
  rows = new Array<any>();
  temp = [];
  columns = [];
  selectedTableColumns = [];
  columnsToDisplayInDropdown = [];
  data = {};
  offSet;
  rawEvent: any;
  contextmenuRow: any;
  contextmenuColumn: any;
  pageDropDown = [5, 10, 20, 50, 100, 20000];
  pageElements: any = 10;
  ColumnMode = ColumnMode;
  pager: DataTablePagerComponent = new DataTablePagerComponent();
  paginationObject = new PaginationObject();
  queryString = '';
  schema: any;
  NgxCurrencyInputMode = NgxCurrencyInputMode;
  options = { prefix:'', suffix: ' €', thousands: '.', decimal: ',', align: 'left', nullable: true, inputMode: NgxCurrencyInputMode.Natural };
  @Input() sortArray: SortObject[];

  csvOptions: any = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    showTitle: false,
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
  };
  csvExporter = new ExportToCsv(this.csvOptions);
  columnsExist = false;
  showSearch = false;
  searchColumnUpdate = new Subject<any>();
  tableData = null;
  booleanValues = [
    { value: null, name: 'All' },
    { value: 'true', name: 'True' },
    { value: 'false', name: 'False' },
  ];
  userWithOutPerm: boolean = false;
  static NavbarBigComponent: any;
  @HostListener('click', ['$event']) onClick(e) {
    if (
      this.showSearch &&
      !this.columnsNotToFilter.includes(e.target.id) &&
      this.selectedTableColumns.find((el) => el.name == e.target.id)
    ) {
      var columnValue = e.target.innerText;
      var columnName = e.target.id;
      if (this.schema && this.schema[columnName] == 'percentage') {
        columnValue = columnValue.split(' ')[0];
      }
      if (this.schema && this.schema[columnName].toLowerCase() == 'date') {
        if (columnValue !== '') {
          columnValue = columnValue.replaceAll('/', '-');
          let temp = columnValue.split('-');
          columnValue = temp[2] + '-' + temp[1] + '-' + temp[0];
        }
      }
      if (this.schema && this.schema[columnName].toLowerCase() == 'timestamp') {
        if (columnValue !== '') {
          columnValue = columnValue.trim();
          columnValue = columnValue.replaceAll(/\s/g, 'T');
          columnValue = columnValue.replaceAll('/', '-');
          let temp = columnValue.split('-');
          let hours = temp[2].split('T');
          columnValue = hours[0] + '-' + temp[1] + '-' + temp[0] + 'T' + hours[1];
        }
      }
      if (this.schema && this.schema[columnName] == 'currency') {
        columnValue = columnValue.split(' ')[0];
      }
      this.search(columnValue, columnName);
    }
  }

  constructor(
    public http: HttpClient,
    public translate: TranslateService,
    public route: ActivatedRoute,
    private router: Router,
    public cdr: ChangeDetectorRef,
    public userPersonSharedService: UserPersonSharedService,
    public toastService: ToastService,
    public loadingService: LoadingService
  ) {
    this.searchColumnUpdate.pipe(debounceTime(1000), distinctUntilChanged()).subscribe((input) => {
      this.search(input.value ? input.value.toString() : '', input.id);
    });
  }

  convertStringToDate(strDate: string) {
    return StringToDate(strDate);
  }

  generateInitialColumnsAndPagination(data) {
    this.columns = [];
    this.tableData = data.data;
    this.schema = data.schema;
    if (this.tableData.content.length > 0) {
      Object.keys(this.tableData.content[0]).forEach((key, index) => {
        this.columns.push({
          name: key,
          prop: key,
          cellTemplate: this.pickCellTemplate(this.schema[key], key),
          headerTemplate: this.translateCell,
          selected: false,
          width: 130,
        });
      });
      if (!this.userWithOutPerm) {
        this.columns.push({
          name: 'Navigation',
          prop: 'Navigation',
          cellTemplate: this.pickNavigationTemplate(),
          sortable: false,
          selected: false,
          width: 120,
        });
      }

    }
    if (this.tableData.content.length > 0) {
      this.reorderInitialColumns();
    }

    this.rows = this.tableData.content;

    this.page = {
      size: this.tableData.size ? this.tableData.size : this.pageElements,
      totalElements: this.tableData.totalElements,
      totalPages: this.tableData.totalPages,
      pageNumber: this.offSet ? this.offSet : 0,
    };

    const columnsToBeExcluded = [
      'Navigation',
      'status',
      'identificationCodeMnemonic',
      'personaName',
      'personaIdentifier',
      ...this.columnsToExclude,
    ];

    var savedColumns = localStorage.getItem(this.section + '-default-columns')
      ? JSON.parse(localStorage.getItem(this.section + '-default-columns'))
      : [];
    if (savedColumns.length) {
      this.defaultColumns = savedColumns;
    }

    if (this.columnsToDisplayInDropdown?.length == 0 && this.columns.length > 0) {
      var defaultCheckedColumns = this.defaultColumns
        .map((elem: any) => {
          const baseColumn = this.columns.find((c: any) => c.name === elem.name);
          if (baseColumn) {
            baseColumn.selected = true;
            return baseColumn;
          } else {
            console.log("Couldn't find column: " + elem.name);
            return { name: null };
          }
        })
        .filter((col: any) => !columnsToBeExcluded.find((c) => col.name === c));
      const extraColumns = this.columns.filter(
        (column) => !columnsToBeExcluded.concat(defaultCheckedColumns.map((c) => c.name)).find((c) => column.name === c)
      );
      this.columnsToDisplayInDropdown = defaultCheckedColumns.concat(extraColumns);
    }
  }

  getRouteLink(detailId: string, subDetailId: string) {
    if (this.section === 'personas') {
      return `/persona/${detailId}`;
    } else if (this.subsection && subDetailId && this.isMultiForm) {
      return `/persona/${detailId}/${this.section}/${this.subsection}/${subDetailId}`;
    } else if (this.subsection) {
      return `/persona/${detailId}/${this.section}/${this.subsection}`;
    } else if (this.section == 'options') {
      return 'option/' + detailId;
    } else {
      return `/persona/${detailId}/${this.section}/${this.subsection}`;
    }
  }

  getPermission() {
    let permissions = JSON.parse(localStorage.getItem("PERMISSIONS"));
    if (permissions && (Object.keys(permissions.permissions).length === 0)) {
      this.userWithOutPerm = true;
    }
  }

  async ngOnInit() {
    this.getPermission();
    var query = '';
    if (window.location.search.includes('?query')) {
      query = decodeURIComponent(window.location.search.split('query=')[1]);
    } else {
      if (!this.router.url.includes('/administration/')) {
        query = '(status==' + encodeURIComponent('ACTIVE') + ")";
      }
    }
    if (window.location.search.includes('sort')) {
      var sortString = window.location.search.split('sort=')[1];
      if (sortString.includes('&')) {
        sortString = sortString.split('&')[0];
      }
      this.sortArray = [];
      this.sortArray.push({ prop: sortString.split(',')[0], dir: sortString.split(',')[1] });
    } else {
      if (this.router.url == '/dashboard/personas') {
        this.sortArray = [{ dir: 'desc', prop: 'updated_at' }];
      }
      localStorage.removeItem('personas-default-sort');
    }
    /*     if (!this.router.url.includes('/administration/')) {
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { sort: sortString, query: query },
            queryParamsHandling: 'merge',
          });
        } */
    let defaultSort = localStorage.getItem(this.section + '-default-sort');
    if (defaultSort) {
      this.sortArray = JSON.parse(defaultSort);
    }
    this.queryString = query;
    await this.fetchData({
      paginationObject: new PaginationObject(),
      sortArray: this.sortArray,
      query: '&query=' + encodeURIComponent(this.queryString),
    });
    this.columns = [...this.columns];
    if (this.defaultColumns.length > 0) {
      this.selectTableColumns(this.defaultColumns);
    }
    /* we need to parse values and fill in input boxes of the search */
    if (query.length > 0) {
      let fillValues = query.split(/[;]+/);
      fillValues.forEach((q, i) => {
        let name = fillValues[i].split('==')[0];
        let value = fillValues[i].split('==')[1];
        if (this.selectedTableColumns.find((el) => el.name == name) && name !== 'status') {
          this.showSearch = true;
          if (value.includes('*')) {
            value = value.split("*")[1];
          }
          this.selectedTableColumns.find((el) => el.name == name).searchValue = value;
        }
      });
      this.queryString = decodeURIComponent(window.location.search.split('?query=')[1]);
      if (this.queryString == 'undefined') {
        this.queryString = '(status==ACTIVE)'
      }
    }
    /* fill inputs done */
  }

  async fetchData(data) {
    if (this.router.url == '/dashboard/personas' && data.sortArray.length == 0) {
      data.sortArray = [{ dir: 'desc', prop: 'updated_at' }];
    }
    if (data.paginationObject) {
      this.offSet = data.paginationObject.offSet;
    }

    var result = await this.service(data.paginationObject, data.sortArray, data.query);

    this.generateInitialColumnsAndPagination(result);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // moving footer inside the body so it has box shadow as per design
      var footer = document.getElementsByClassName('datatable-footer')[0];
      var body = document.getElementsByClassName('datatable-body')[0];
      if(body != null && typeof body != typeof undefined){
        body.appendChild(footer);
      }
    }, 10);
  }

  setPage(pageInfo) {
    this.paginationObject = pageInfo;
    this.columnsExist = true;
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    this.fetchData({ paginationObject: pageInfo, sortArray: this.sortArray, query: query });
  }

  setPageSize(event: any) {
    const value = event.target.value;
    let size;
    if (value === 'All') { // Se viene selezionato 'All', imposta size a 20000
      size = 20000; 
    } else {
      size = Number(value);
    }
    let pagination = { pageSize: size, offset: 0, limit: size }
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    this.offSet = 0;
    this.pageElements = size;
    this.page.pageNumber = this.paginationObject.offset;
    this.fetchData({ paginationObject: pagination, sortArray: this.sortArray, query: query });
  }

  onSort(event) {
    this.sortArray = event.sorts;
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    let sortQuery = sortHelper.constructSort(this.sortArray, true).split('sort=')[1];
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { sort: sortQuery },
      queryParamsHandling: 'merge',
    });
    let pagination = {
      count: 0,
      limit: this.pageElements,
      offset: 0,
      pageSize: this.pageElements
    }
    localStorage.setItem(this.section + '-default-sort', JSON.stringify(this.sortArray));
    this.fetchData({ paginationObject: pagination, sortArray: event.sorts, query: query });
  } 

  selectTableColumns(event, addNewColumn?: boolean) {
    var columnsToBeExcluded = ['Navigation', 'personaIdentifier', ...this.columnsToExclude];
    /* if removing column */
    var duplicate;
    event.forEach((x) => {
      var count = 0;
      event.forEach((y) => {
        if (x.name == y.name) {
          count++;
          if (count > 1) duplicate = x;
        }
      });
    });

    if (duplicate) {
      _.remove(event, {
        name: duplicate.name,
      });
      this.columns.forEach((element) => {
        if (element.name == duplicate.name) {
          element.selected = false;
        }
      });
      this.removeFromSort(duplicate.name);
      this.removeFromQuery(duplicate.name);
    }
    /* removing colum end */

    /* order columns by default order from the backend */
    let orderColumnsList = [];
    Object.keys(this.schema).forEach(scEl => {
      orderColumnsList.push({ name: scEl });
    });

    this.selectedTableColumns = [];
    this.columnsToDisplayInDropdown = this.columns;
    let sortedEventArray = orderColumnsList.map((el: any) => {
      return event.find((eventEl: any) => eventEl.name === el.name);
    });
    sortedEventArray = sortedEventArray.filter((el) => el !== undefined);
    sortedEventArray = sortedEventArray.length == 0 ? event : sortedEventArray;

    /* order columns by default order from the backend end*/

    sortedEventArray.forEach((el) => {
      this.columns.forEach((element) => {
        if (element.name == el.name) {
          element.selected = true;
        }
      });
      if (el.name !== 'Navigation' && !columnsToBeExcluded.find((e) => e === el.name)) {
        this.selectedTableColumns.push({
          name: el.name,
          prop: el.name,
          searchValue: el.searchValue,
          cellTemplate: this.pickCellTemplate(this.schema[el.name], el.name),
          headerTemplate: this.translateCell,
          selected: false,
          width: 130,
        });
      }
    });
    if (!this.userWithOutPerm) {
      this.selectedTableColumns.push({
        name: 'Navigation',
        prop: 'Navigation',
        cellTemplate: this.pickNavigationTemplate(),
        sortable: false,
        selected: false,
        width: 120,
      });
    }

    columnsToBeExcluded.push('status', 'identificationCodeMnemonic', 'personaName');
    // remove fitler, custom id and persona name from dropdown
    this.columnsToDisplayInDropdown = this.columnsToDisplayInDropdown.filter(
      (column: any) => !columnsToBeExcluded.find((c) => column.name === c)
    );

    this.columnsToDisplayInDropdown = orderColumnsList.map((el: any) => {
      return this.columnsToDisplayInDropdown.find((columnsToDisplayInDropdown: any) => columnsToDisplayInDropdown.name === el.name);
    }).filter(element => {
      return element !== undefined;
    })

    if (addNewColumn && !duplicate) {
      this.refreshData();
    }
    var selectedColumns = [];
    this.columns.forEach((column) => {
      if (this.selectedTableColumns.find((selectedColumn) => selectedColumn.name === column.name)) {
        selectedColumns.push({ name: column.name });
      }
    });
    localStorage.setItem(this.section + '-default-columns', JSON.stringify(selectedColumns));
  }

  selectAllColumns() {
    this.selectTableColumns(this.columns);
  }

  unselectAllColumns() {
    const columnsToKeep = this.columns.filter(
      (col) => col.name == 'status' || col.name == 'identificationCodeMnemonic' || col.name == 'personaName'
    );

    this.selectedTableColumns.forEach((col) => {
      this.selectTableColumns([col, ...columnsToKeep]);
    });
    this.columns.forEach((col) => (col.selected = false));
  }

  async exportCSV() {
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    let result = await this.service({ pageSize: this.page.totalElements }, this.sortArray, query);
    var columns = this.selectedTableColumns;
    this.columnsToExclude.forEach((columnToExclude) => {
      columns = columns.filter((el) => el.name !== columnToExclude);
    });
    var dataToExport = result.data;
    var data = dataToExport.content;
    // we want export only data that is shown in the selected columns
    const dataForExport = data.map((o) =>
      columns.reduce((acc, curr) => {
        if (curr.name !== 'Navigation') {
          let translatedColumnName: any = this.translate.instant('columnName.' + curr.name);
          acc[translatedColumnName] = o[curr.name] ? o[curr.name] : '';
        }
        return acc;
      }, {})
    );

    let subsection = this.subsection ? (this.section ? '_' : '') + this.subsection : '';
    let section = this.section ? this.section : '';

    this.csvExporter.options.filename = section + subsection + '-' + moment().toISOString();
    this.csvExporter.generateCsv(dataForExport);
  }

  async copyToClipboard() {
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    let result = await this.service({ pageSize: this.page.totalElements }, this.sortArray, query);
    var columns = this.selectedTableColumns;
    this.columnsToExclude.forEach((columnToExclude) => {
      columns = columns.filter((el) => el.name !== columnToExclude);
    });
    var dataToExport = result.data;
    const data = dataToExport.content;
    // we want export only data that is shown in the selected columns
    const dataForExport = data.map((o) =>
      columns.reduce((acc, curr) => {
        if (curr.name !== 'Navigation') {
          let translatedColumnName: any = this.translate.instant('columnName.' + curr.name);
          acc[translatedColumnName] = o[curr.name] ? o[curr.name] : '';
        }
        return acc;
      }, {})
    );
    navigator.clipboard.writeText(copy2DArrayToClipboard(dataForExport)).then(() => {
      this.toastService.showSuccess('Copied to Clipboard!');
    });
  }

  displaySearch() {
    this.showSearch = !this.showSearch;
    var cells: any = document.getElementsByTagName('datatable-header-cell');
    for (let i = 0; i < cells.length; i++) {
      if (this.showSearch) {
        cells[i].classList.add('datatable-header-cell-search');
      } else {
        cells[i].classList.remove('datatable-header-cell-search');
      }
    }
  }

  async search(columnValue, columnName) {
    var searchValue = columnValue;

    var searchName = columnName;
    if (this.schema && this.schema[columnName] == 'percentage' && columnValue.length > 0) {
      if (columnValue.includes('%')) {
        columnValue = columnValue.slice(0, -1);
      }
      columnValue = columnValue.split(',').join('.');
      searchValue = Number(columnValue / 100).toFixed(4);
    }
    if (this.schema && this.schema[columnName] == 'currency') {
      if (columnValue.length > 0) {
        let tempCalc = columnValue;
        let separator = columnValue.includes(",") ? "," : ".";
        let thousands = parseFloat(columnValue.split(' ')[0].split(separator)[0].replace('.', ''));
        let decimals = parseFloat(columnValue.split(' ')[0].split(separator)[1]);
        let decimalNumber = thousands.toString();
        if (decimals > 0) {
          decimalNumber = thousands + '.' + decimals;
        }
        searchValue = decimalNumber.replace(',', '');
        columnValue = searchValue;
      } else {
        columnValue = null;
      }
    }
    this.selectedTableColumns.find((el) => el.name == searchName).searchValue = columnValue;
    var newQuery;
    if (this.schema[columnName] == 'text' || this.schema[columnName] == 'STRING') {
      if (window.location.pathname.includes('/dashboard/personas') && (searchValue == 'NULL' ||
        this.schema[columnName].toLowerCase() == 'date' ||
        this.schema[columnName].toLowerCase() == 'timestamp' ||
        this.schema[columnName].toLowerCase() == 'number' ||
        this.schema[columnName].toLowerCase() == 'percentage' ||
        this.schema[columnName].toLowerCase() == 'time')) {
        newQuery = searchName + '==' + searchValue;
      } else {
        newQuery = searchName + '==*' + searchValue + '*';
      }
    } else {
      newQuery = searchName + '==' + searchValue;
    }
    if (searchValue.trim().length == 0) {
      this.removeFromQuery(searchName);
      return;
    }
    if (this.queryString.includes(searchName)) {
      var queries = this.queryString.split('==');
      var valueIndex;
      queries.forEach((q, i) => {
        if (q.includes(searchName)) {
          valueIndex = i + 1;
        }
      });
      if (queries[valueIndex].includes(';')) {
        let values = queries[valueIndex].split(';');
        values[0] = (this.schema[columnName].toLowerCase() !== 'date' && this.schema[columnName].toLowerCase() !== 'time' && this.schema[columnName].toLowerCase() !== 'currency' && this.schema[columnName].toLowerCase() !== 'percentage' && this.schema[columnName].toLowerCase() !== 'number' && this.schema[columnName].toLowerCase() !== 'timestamp' && this.schema[columnName].toLowerCase() !== 'boolean') ? '*' + searchValue + '*' : searchValue;
        queries[valueIndex] = values.join(';');
      } else {
        queries[valueIndex] = (this.schema[columnName].toLowerCase() !== 'date' && this.schema[columnName].toLowerCase() !== 'time' && this.schema[columnName].toLowerCase() !== 'currency' && this.schema[columnName].toLowerCase() !== 'percentage' && this.schema[columnName].toLowerCase() !== 'number' && this.schema[columnName].toLowerCase() !== 'timestamp' && this.schema[columnName].toLowerCase() !== 'boolean') ? '*' + searchValue + '*' : searchValue;
      }
      this.queryString = queries.join('==');
    } else {
      if (this.queryString.length > 0) {
        this.queryString += ';' + newQuery;
      } else {
        this.queryString += newQuery;
      }
    }

    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    query = query.replace(new RegExp('%2C', 'g'), '\,')
    this.queryString = this.queryString.replace(new RegExp(',', 'g'), '\,')
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { query: this.queryString },
      queryParamsHandling: 'merge',
    });

    let pagination = {
      count: 0,
      limit: this.pageElements,
      offset: 0,
      pageSize: this.pageElements
    }
    await this.fetchData({ paginationObject: pagination, sortArray: this.sortArray, query: query });
    this.tableComponent.offset = 0;
  }

  async statusFilter(status) {
    if (this.queryString == 'undefined') {
      this.queryString = "(status==ACTIVE)";
    }
    this.removeFromQuery('status', false);
    var finalQuery = this.queryString;
    if (status.length) {
      finalQuery = this.queryString + ';' + status;
    }

    var query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(finalQuery) : '';
    if (this.queryString.length == 0 && status.length > 0) {
      query = '&query=' + encodeURIComponent(status);
      finalQuery = status;
    }
    this.queryString = finalQuery;
    if (this.queryString.length) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { query: this.queryString },
        queryParamsHandling: 'merge',
      });
    }

    await this.fetchData({ paginationObject: new PaginationObject(), sortArray: this.sortArray, query: query });
  }

  async removeFromQuery(key, refresh: boolean = true) {
    if (this.queryString.includes(key)) {
      var queries = this.queryString.split(';');
      var valueIndex;
      queries.forEach((q, i) => {
        if (q.includes(key)) {
          valueIndex = i;
        }
      });
      queries.splice(valueIndex, 1);
      this.queryString = queries.join(';');
      let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { query: this.queryString },
        queryParamsHandling: 'merge',
      });
      if (refresh) {
        let pagination = {
          count: 0,
          limit: this.pageElements,
          offset: 0,
          pageSize: this.pageElements
        }
        await this.fetchData({ paginationObject: pagination, sortArray: this.sortArray, query: query });
      }
    }
  }

  async removeFromSort(key) {
    this.sortArray = this.sortArray.filter((el) => el.prop !== key);
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    await this.fetchData({ paginationObject: new PaginationObject(), sortArray: this.sortArray, query: query });
  }

  inputType(columnName: string) {
    if (this.schema && this.schema[columnName] == 'percentage') {
      return 'number';
    }
    if (this.schema && this.schema[columnName]) {
      return this.schema[columnName];
    } else {
      return 'text';
    }
  }

  clearSearchValue(columnName: string) {
    this.selectedTableColumns.find((el) => el.name == columnName).searchValue = '';
    this.selectedTableColumns = [...this.selectedTableColumns];
    this.search('', columnName);
  }

  async clearSearch() {
    this.filtersComponent.statusActive = true
    this.filtersComponent.statusArchived = false;
    this.queryString = '(status==' + encodeURIComponent('ACTIVE') + ")";
    this.pageElements = 10;
    this.paginationObject.offset = 0;
    this.selectedTableColumns.forEach((e) => {
      e.searchValue = null;
    });
    
    if (!this.router.url.includes('/administration/')) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { sort: sortHelper.constructSort(this.sortArray, true).split('sort=')[1], query: this.queryString },
      });
      await this.fetchData({
        paginationObject: new PaginationObject(),
        sortArray: this.sortArray,
        query: '&query=' + this.queryString,
      });
    }

    this.displaySearch();
  }

  async refreshData() {
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    //set up the table page number 
    if (this.tableComponent)
      this.tableComponent.offset = 0;
    //set up the page number in the call
    if (this.paginationObject)
      this.paginationObject.offset = 0;
    await this.fetchData({ paginationObject: this.paginationObject, sortArray: this.sortArray, query: query });

  }

  arraymove(arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }

  addNewColumn(event) {
    this.selectTableColumns(event, true);
  }

  pickCellTemplate(schemaKey: string, columnName: string) {
    switch (columnName) {
      case 'personaName':
      case 'superiorName':
        return this.personNameCell;
      default:
        break;
    }
    switch (schemaKey) {
      case 'percentage':
        return this.percentageCell;
      case 'time':
        return this.timeCell;
      case 'date':
        return this.dateCell;
      case 'currency':
        return this.currencyCell;
      case 'text':
      case 'boolean':
        return this.plainCell;
      case 'number':
        return this.numberCell;
      default:
        if (columnName !== 'identifier')
          console.warn('Found ' + columnName + ' which is not in schema. Defaulting to text input.');
        return this.plainCell;
    }
  }

  public greenEyeTooltip: string;
  pickNavigationTemplate() {
    if (this.subsection === 'user-management') {
      this.greenEyeTooltip = this.translate.instant('administration.userManagement.goto');
      return this.greenEyeIconAdmin;
    }
    if (this.section === 'options') {
      this.greenEyeTooltip = this.translate.instant('administration.options.goto');
      return this.greenEyeIconAdmin;
    } else {
      this.greenEyeTooltip = this.translate.instant('dashboard.personaDetails');
      return this.greenEyeIconHomepage;
    }
  }

  reorderInitialColumns() {
    if (this.columns.find((e) => e.name == 'status')) {
      this.arraymove(
        this.columns,
        this.columns.findIndex((e) => e.name == 'status'),
        0
      );
    }
    if (this.columns.find((e) => e.name == 'identificationCodeMnemonic')) {
      this.arraymove(
        this.columns,
        this.columns.findIndex((e) => e.name == 'identificationCodeMnemonic'),
        1
      );
    }
    if (this.columns.find((e) => e.name == 'personaName')) {
      this.arraymove(
        this.columns,
        this.columns.findIndex((e) => e.name == 'personaName'),
        2
      );
    }
    // start and end date have to be at begining of the table columns.. if exist..
    if (this.columns.find((e) => e.name == 'dateStart')) {
      this.arraymove(
        this.columns,
        this.columns.findIndex((e) => e.name == 'dateStart'),
        3
      );
      this.arraymove(
        this.columns,
        this.columns.findIndex((e) => e.name == 'dateEnd'),
        4
      );
    }
  }

  async exportSheet() {
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    let result = await this.service({ pageSize: this.page.totalElements }, this.sortArray, query);

    let subsection = this.subsection ? (this.section ? '_' : '') + this.subsection : '';
    let section = this.section ? this.section : '';

    var filename = section + subsection + '-' + moment().toISOString();

    const columns = this.selectedTableColumns;
    const data = result.data.content;

    var spreadsheetBody = {
      properties: {
        title: filename + '-' + moment().toISOString(),
      },
      sheets: [
        {
          //sheet1
          properties: {
            title: 'Sheet1',
            gridProperties: {
              columnCount: columns.find((el) => el.name === 'Navigation') ? columns.length - 1 : columns.length,
              rowCount: data.length + 1,
              frozenRowCount: 1,
            },
            tabColor: {
              red: 1.0,
              green: 0.3,
              blue: 0.4,
            },
          },
        },
      ],
    };
    this.loadingService.pushLoadingRequests('sheets api');
    // first we create the spreadsheet
    this.token.callback = (resp) => {
      if (resp.error !== undefined) {
        console.error("TOKEN", resp);
        throw (resp);
      }
      gapi.client.sheets.spreadsheets
        .create(() => { }, spreadsheetBody)
        .then(
          (response) => {
            // we want export only data that is shown in the selected columns
            const dataForExport = data.map((o) =>
              columns.reduce((acc, curr) => {
                if (curr.name !== 'Navigation') {
                  let translatedColumnName: any = this.translate.instant(curr.name);
                  acc[translatedColumnName] = o[curr.name] ? o[curr.name].toString() : '';
                }
                return acc;
              }, {})
            );
            var sheetDataArray = [];
            let columnArray = [];
            columns.forEach((col) => {
              if (col.name !== 'Navigation') columnArray.push(col.name);
            });
            sheetDataArray.push(columnArray);
            let dataArray = dataForExport.map(Object.values);
            dataArray.forEach((data) => {
              sheetDataArray.push(data);
            });
            // when sheet created we update it with data
            gapi.client.sheets.spreadsheets
              .batchUpdate(
                {
                  spreadsheetId: response.result.spreadsheetId,
                },
                {
                  requests: [
                    {
                      pasteData: {
                        coordinate: {
                          sheetId: response.result.sheets[0].properties.sheetId,
                          rowIndex: 0,
                          columnIndex: 0,
                        },
                        data: copy2DArrayToClipboard(dataForExport),
                        type: 'PASTE_NORMAL',
                        delimiter: '\t',
                      },
                    },
                    {
                      autoResizeDimensions: {
                        dimensions: {
                          sheetId: response.result.sheets[0].properties.sheetId,
                          dimension: 'COLUMNS',
                          startIndex: 0,
                          endIndex: columns.find((el) => el.name === 'Navigation') ? columns.length - 1 : columns.length,
                        },
                      },
                    },
                    {
                      addBanding: {
                        bandedRange: {
                          range: {
                            sheetId: response.result.sheets[0].properties.sheetId,
                            startRowIndex: 0,
                            endRowIndex: data.length + 1,
                            startColumnIndex: 0,
                            endColumnIndex: columns.find((el) => el.name === 'Navigation')
                              ? columns.length - 1
                              : columns.length,
                          },
                          rowProperties: {
                            headerColor: {
                              red: 0.7,
                              green: 0.7,
                              blue: 0.7,
                              alpha: 1,
                            },
                            firstBandColor: {
                              red: 0.9,
                              green: 0.9,
                              blue: 0.9,
                              alpha: 1,
                            },
                            secondBandColor: {
                              red: 1,
                              green: 1,
                              blue: 1,
                              alpha: 0,
                            },
                          },
                        },
                      },
                    },
                    {
                      repeatCell: {
                        range: {
                          sheetId: response.result.sheets[0].properties.sheetId,
                          startRowIndex: 0,
                          endRowIndex: 1,
                        },
                        cell: {
                          userEnteredFormat: {
                            textFormat: {
                              bold: true,
                            },
                          },
                        },
                        fields: 'userEnteredFormat.textFormat.bold',
                      },
                    },
                  ],
                }
              )
              .then(
                () => {
                  this.toastService.showSuccess(
                    `Spreadsheet export is completed, click <a target='_blank' style="color: white !important; font-weight: bold;" href='${response.result.spreadsheetUrl}'>here</a> to open the file`,
                    10000
                  );
                  var win = window.open(response.result.spreadsheetUrl, '_blank');
                  if (win) {
                    win.focus();
                  }
                  this.loadingService.popLoadingRequests();
                  document.getElementById('close-export-dropdown').click();
                },
                (err) => {
                  this.loadingService.popLoadingRequests();
                  this.toastService.showError('Something happened');
                  console.log(err);
                  document.getElementById('close-export-dropdown').click();
                }
              );
          },
          (reason) => {
            this.loadingService.popLoadingRequests();
            this.toastService.showError('Something happened');
            console.log(reason);
            document.getElementById('close-export-dropdown').click();
          }
        );
    }

    if (gapi.client.getToken() === null) {
      // Prompt the user to select a Google Account and asked for consent to share their data
      // when establishing a new session.
      this.token.requestAccessToken({ prompt: 'consent' });
    } else {
      // Skip display of account chooser and consent dialog for an existing session.
      this.token.requestAccessToken({ prompt: '' });
    }

  }

  defaultColumnsReset() {
    localStorage.removeItem(this.section + '-default-columns');
    window.location.reload();
  }

  getColor(columnName) {
    return '#eeeeee'
    /* if(columnName === 'personaName'){
      return '#FFFFFF'
    }else if(columnName === 'updated'){
      return '#000000'
    }else{
      return '#eeeeee'
    }
  */

  }

  setToken(tk: any) {
    this.token = tk;
  }
}
